import { render } from "./createRate.vue?vue&type=template&id=395ccf78&scoped=true"
import script from "./createRate.vue?vue&type=script&lang=js"
export * from "./createRate.vue?vue&type=script&lang=js"

import "./createRate.vue?vue&type=style&index=0&id=395ccf78&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395ccf78"]])

export default __exports__